<template>
  <div>
    <van-popup v-model="visible" position="bottom">
      <van-nav-bar
        :title="obj.TblName"
        left-text="返回"
        left-arrow
        @click-left="visible = false"
      />

      <div class="main">
        <van-grid column-num="4" clickable>
          <van-grid-item v-for="i in 12" :key="i" @click="custtotal = i">
            <div class="text-size">{{ i }}</div>
          </van-grid-item>
        </van-grid>
        <van-row style="margin: 1rem">
          <van-col span="12" align="center">
            <van-icon name="friends-o" size="40" />
            <div class="text-size">客數</div>
          </van-col>
          <van-col span="12" align="center">
            <!-- <el-button
              type="text"
              icon="el-icon-remove-outline"
              circle
              :disabled="!allowSub()"
              @click="cmd0"
              class="font-x2"
            /> -->
            <span style="font-size: 3rem; line-height: 5rem" class="C1">{{
              custtotal
            }}</span>
            <!-- <el-button
              type="text"
              icon="el-icon-circle-plus-outline"
              circle
              @click="cmd1"
              class="font-x2"
            /> -->
          </van-col>
        </van-row>
      </div>

      <Footer
        :b1="getBtnText()"
        @b1c="$emit('open', obj.TblName, custtotal)"
        :anime="custtotal > 0"
      />
      <!-- <van-tabbar fixed placeholder>
        <van-button @click="$emit('open', obj.TblName, custtotal, ordertmp)">
          開桌
        </van-button>
      </van-tabbar> -->
    </van-popup>
  </div>
</template>

<style scoped>
/* .van-col {
  font-size: 1rem;
  min-height: 3rem;

  margin-top:1.6rem;
} */
.van-icon {
  font-size: 2rem;
}
.font-x2 {
  font-size: 2rem;
}
.font-x3 {
  font-size: 3rem;
  padding: 2rem;
}
.font-x4 {
  font-size: 4rem;
  margin: 1rem;
}
</style>

<script>
// import MenuPick from "./Popup/FrmMenuPick.vue";
import Footer from "./Popup/Child/Footer.vue";
export default {
  components: { Footer },
  data() {
    return {
      visible: false,
      title: "",
      obj: {},
      custtotal: 0,
      loading: false,
      items: [],
      bkmenu: null,
      // ordertmp: null,
      anime: true,
    };
  },
  async mounted() {
    console.log("BKMenu.monted");
    await this.init();
    // this.gLoading();
    // await this.refresh();
    // this.gClear();

    // setInterval(() => {
    //   this.refresh();
    // }, 60 * 1000);
  },
  methods: {
    getBtnText() {
      if (this.custtotal == 0) return "請選擇客數";
      return this.obj.TblName + " 開桌" + this.custtotal + "位";
    },
    show(data) {
      this.custtotal = 0;
      // this.ordertmp = [
      //   { ItemName: "#1", Qty: 0 },
      //   { ItemName: "#2", Qty: 0 },
      //   { ItemName: "#3", Qty: 0 },
      //   { ItemName: "#4", Qty: 0 },
      //   { ItemName: "#5", Qty: 0 },
      //   { ItemName: "#6", Qty: 0 },
      // ];
      this.obj = data;
      this.visible = true;
    },

    // setItem(pIndex, pObj) {
    // console.log("setItem", pIndex, pObj);
    // this.ordertmp[pIndex] = pObj;
    // this.ordertmp[pIndex]= pObj;
    // this.ordertmp.splice(pIndex, 1, pObj);
    // },
    allowSub() {
      if (this.custtotal > 0) {
        return true;
      }
      return false;
    },
    cmd0() {
      this.custtotal--;
      if (this.custtotal < 1) return (this.custtotal = 1);
    },
    cmd1() {
      this.custtotal++;
      if (this.custtotal > 12) return (this.custtotal = 12);
    },
    add(pItem) {
      pItem.qty++;
    },
    sub(pItem) {
      pItem.qty--;
      if (pItem.qty < 0) pItem.qty = 0;
    },
    close() {
      this.obj = {};
      this.visible = false;
    },
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        // this.$store.state.config = this.bkmenu.config;
        // this.$store.state.exttype = this.bkmenu.exttype;
        // console.log("bkmenu", this.bkmenu);
        // let extitem = this.bkmenu.extitem;
        // if (extitem[0]) this.items.push(extitem[0]);
        // if (extitem[1]) this.items.push(extitem[1]);
      } catch (error) {
        console.log(error.toString());
      }
    },
  },
};
</script>
